import { useDialogControlContext } from "../context";

export const useOpenDialog = () => {
  const context = useDialogControlContext();

  if (!context) {
    throw new Error("useOpenDialog must be used within a DialogContext");
  }

  return context.openDialog;
};
